import { 
   setBreadcrumb
} from './actions';

 
const dispatchsetBreadcrumb = (dispatch:any) => (loaclparma:any) =>{
  dispatch(setBreadcrumb(loaclparma));
}
 
const operations = {
  dispatchsetBreadcrumb
};

export default operations;
